import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/pagination";

export default class extends Controller {
  initialize() {
    this.handleResize();
  }

  initializeSwiper() {
    this.swiper = new Swiper(".js-event-detail-slider", {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 20,
      speed: 300,
      slidesPerView: 1,
      centeredSlides: true,
      pagination: {
        el: ".js-event-detail-slider-pagination",
        clickable: true,
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
  }

  handleResize() {
    var slideCount = $(".js-event-detail-slider").find(".swiper-slide").length;

    if (slideCount === 1) {
      this.destroySwiper();
      $(".js-event-detail-slider").addClass("is-single");
    } else {
      if (!this.swiper) {
        this.initializeSwiper();
      }
    }
  }

  //再生/停止ボタン
  sliderstop(e) {
    if (this.swiper) {
      if ($(e.currentTarget).hasClass("is-pause")) {
        this.swiper.autoplay.start();
        $(e.currentTarget).removeClass("is-pause");
        $(e.currentTarget).text("停止する");
      } else {
        this.swiper.autoplay.stop();
        $(e.currentTarget).addClass("is-pause");
        $(e.currentTarget).text("再生する");
      }
    }
  }
}
